const CorTypes = {
    STATES: 1,
    VENDORS: 2,
};

export default CorTypes;